import BaseModel from "../../core/components/input-widget/BaseModel";
import i18n from "../../shared/i18n";
import {Formatter} from "@/core/services/formatter.service";

export default class DebitNoteModel extends BaseModel {
  comment = null;
  date = Formatter.getCurrentDate();
  attributeLabels = {
    comment: i18n.t('Comment'),
    date: i18n.t('Date'),
  };

  rules = {};

  attributeHints = {}

  constructor(data = {}) {
    super();
    Object.assign(this, {...data});
  }
}